import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/prv/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/prv/';

class ProcessPpvService {
  getAll() {
    return axios.get(API_URL + `processppv/all`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `processppv/${id}`, { headers: authHeader() });
  }

  create(processPpv) {
    return axios.post(API_URL + `processppv/cre`, {
      memberId: processPpv.memberId,
      totalPpv: processPpv.totalPpv,
      totalNdc: processPpv.totalNdc,
      monthlyPpv: processPpv.monthlyPpv,
      monthlyNdc: processPpv.monthlyNdc,
      networkLevel: processPpv.networkLevel,
      userLevel: processPpv.userLevel,
      month: processPpv.month,
      year: processPpv.year
    }, { headers: authHeader() });
  }

  update(id, processPpv) {
    return axios.put(API_URL + `processppv/${id}/upd`, {
      id: processPpv.id,  
      memberId: processPpv.memberId,
      totalPpv: processPpv.totalPpv,
      totalNdc: processPpv.totalNdc,
      monthlyPpv: processPpv.monthlyPpv,
      monthlyNdc: processPpv.monthlyNdc,
      networkLevel: processPpv.networkLevel,
      userLevel: processPpv.userLevel,
      month: processPpv.month,
      year: processPpv.year
    }, { headers: authHeader() });
  }

  updateProcessPpvLevel(memberId, level, month, year) {
    return axios.put(API_URL + `processppv/${memberId}/${level}/${month}/${year}/updlevel`, {
      memberId: memberId,
      level: level,
      month: month,
      year: year
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getProcessPpvsByMember(memberId) {
    return axios.get(API_URL + `processppv/${memberId}/member`, { headers: authHeader() });
  }
  
  getProcessPpvByMemberMonthAndYear(memberId, month, year) {
    return axios.get(API_URL + `processppv/${memberId}/${month}/${year}/membermonthyear`, { headers: authHeader() });
  }

  getProcessPPVCountByMonthAndYear(month, year) {
    return axios.get(API_URL + `processppv/${month}/${year}/countbymonthandyear`, { headers: authHeader() });
  }

  calculateProcessPPV(month, year) {
    return axios.get(API_URL + `processppv/${month}/${year}/calprocessppvbymonthandyear`, { headers: authHeader() });
  }

  calculateLevelData(month, year) {
    return axios.get(API_URL + `processppv/${month}/${year}/calculateleveldata`, { headers: authHeader() });
  }
  
}

export default new ProcessPpvService();